import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  ChartData,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { IChartDot, IDailyStatistics } from '../../lib/interfaces'; // MINIMAL FIX: Imported IChartDot
import { MHColours } from '../../constants/theme';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

export interface LineChartProps {
  chartStatistics?: IDailyStatistics;
  chartType: string;
  labels: string[];
}

const LineChart = (props: LineChartProps) => {
  const { chartStatistics, labels, chartType } = props;

  const options = {
    scales: {
      x: {
        min: labels[0],
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
    bezierCurve: true,
  };

  const datasets: Array<{
    label: string;
    borderColor: string;
    backgroundColor: string;
    data?: IChartDot[];
  }> = [
    {
      label: 'Migran',
      borderColor: MHColours.mhMigraineBlue,
      backgroundColor: MHColours.mhMigraineBlue,
      data: chartStatistics?.migraines,
    },
    {
      label: 'Spänningshuvudvärk',
      borderColor: MHColours.mhMigrainePurpleLight,
      backgroundColor: MHColours.mhMigrainePurpleLight,
      data: chartStatistics?.tesnionHeadaches,
    },
    {
      label: 'Horton',
      borderColor: MHColours.mhMigraineYellow,
      backgroundColor: MHColours.mhMigraineYellow,
      data: chartStatistics?.hortons,
    },
    {
      label: 'Annan Huvudvärk',
      borderColor: MHColours.mhMigraineOrange,
      backgroundColor: MHColours.mhMigraineOrange,
      data: chartStatistics?.otherHeadaches,
    },
  ];

  if (chartType === 'month') {
    datasets.push({
      label: 'Huvudvärk',
      borderColor: MHColours.mhMigraineRed,
      backgroundColor: MHColours.mhMigraineRed,
      data: chartStatistics?.headaches,
    });
  }

  const filteredDatasets = datasets.filter(({ data }) =>
    data?.some(({ y }) => y !== undefined && y !== null)
  );

  const data = {
    labels,
    datasets: filteredDatasets as ChartData<'line', IChartDot[]>['datasets'],
  };

  return <Line options={options} data={data} />;
};

export default LineChart;
